import {AccountLayoutComponent} from '@account/components/layout/account-layout.component';
import {AccountLoginIdpComponent} from '@account/components/login-idp/account-login-idp.component';
import {AccountOauthCallbackComponent} from '@account/components/oauth-callback/oauth-callback.component';
import {BrowserCompatibilityGuard} from '@shared/guards/compatibility-guard.service';
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

const routes: Routes = [
  {
    path: 'account', component: AccountLayoutComponent, canActivate: [BrowserCompatibilityGuard],
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      { path: 'login', component: AccountLoginIdpComponent },
      { path: 'oauth-callback', component: AccountOauthCallbackComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BavelAccountRoutingModule { }
